import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "./store/store"

interface PokalApiToasterState {
    configured: boolean
    message: {
        title: string
        content: string
    } | null
}

const name = "pokalApiToaster"
const initialState: PokalApiToasterState = {
    configured: false,
    message: null
}

const pokalApiToaster = createSlice({
    name,
    initialState,
    reducers: {
        setPokalApiToasterMessage: (
            state,
            action: PayloadAction<{ title: string; message: string }>
        ) => {
            state.message = {
                title: action.payload.title,
                content: action.payload.message
            }
        },
        resetPokalApiToasterMessage: (state) => {
            state.message = null
        },
        pokalApiConfigured: (state) => {
            state.configured = true
        }
    }
})

export const {
    setPokalApiToasterMessage,
    resetPokalApiToasterMessage,
    pokalApiConfigured
} = pokalApiToaster.actions

export const selectPokalApiToasterMessage = (state: RootState) =>
    state.pokalApiToaster.message
export const selectPokalApiConfiguredState = (state: RootState) =>
    state.pokalApiToaster.configured

export default pokalApiToaster.reducer
